import { get_translations } from "@pdfking/workflow/utils/make_translations"
import render_string from "@pdfking/workflow/utils/render_string"

export default (name: string, ...args): Promise<string> =>
  get_translations("urls").then(urls => render_string(urls[name], ...args))
